import { Point } from 'dragonmouse-shared/geometry';

import { Transfer } from './Transfer';
import { TransferBoard } from './TransferBoard';

export type CompleteFunction = () => void;

export class Target {
	getComplete(board: TransferBoard): CompleteFunction | null {
		// try to process other transfers in order until we've found one
		for (const transfer of board.transfers) {
			const complete = this.getCompleteTransfer(transfer, board);
			if (complete) {
				// Print name of class for debugging purposes
				// console.debug('Target getComplete() succeeded for', this.constructor.name);
				return complete;
			}
		}
		// console.debug('Target getComplete() failed for', this.constructor.name);
		return null;
	}

	getCompleteTransfer(_transfer: Transfer, _board: TransferBoard): CompleteFunction | null {
		return null;
	}
}

export class TargetCanvas extends Target {
	constructor(public readonly scene: Point) {
		super();
	}

	getCompleteTransfer(transfer: Transfer, _board: TransferBoard): CompleteFunction | null {
		// if (transfer instanceof TransferFrame) {
		// 	return async () => {
		// 		const frame = (transfer as TransferFrame).frame;
		// 		const newFrame = new Frame(
		// 			null,
		// 			this.scene.x,
		// 			this.scene.y,
		// 			frame.width,
		// 			frame.height,
		// 			frame.label,
		// 			frame.url
		// 		);
		// 		store.dispatch(addFrame(newFrame));
		// 	};
		// }
		return null;
	}
}

export class TargetFolder extends Target {
	constructor(public readonly path: string) {
		super();
	}

	getCompleteTransfer(_transfer: Transfer): CompleteFunction | null {
		return null;
	}
}
